/**
 * 
 * alterFormDefinition callback
 * @link https://docs.ngpvan.com/reference/restyle-credit-card-field
 * 
 */

document.addEventListener('DOMContentLoaded', function () {
    // console.log('reorder ngp fields');
    const inlineNGP = document.querySelectorAll('.form-ngp-base .ngp-inline');

    var nvtag_callbacks = window.nvtag_callbacks = window.nvtag_callbacks || {};
    nvtag_callbacks.alterFormDefinition = nvtag_callbacks.alterFormDefinition || [];

    // reorder
    var reorderFieldsCallback = function (args) {

        let getShortCode = args.form_definition.shortCode;
        const inlineFormClass = document.querySelector('.form-ngp-base .ngp-inline');

        // Need to target just the inline form(s).
        if (inlineFormClass || getShortCode == "D6Rm_OVOg0CVHyrH9BTHLg2") {
            _.each(args.form_definition.form_elements, function (child) {

                if (child.name === 'ContactInformation') {
                    var newFieldSets = [];

                    _.each(child.children, function (element, key, children) {
                        var order = null;

                        switch (element.name) {
                            case 'FirstName':
                                order = 0;
                                break;
                            case 'LastName':
                                order = 1;
                                break;
                            case 'EmailAddress':
                                order = 2;
                                break;
                            case 'PostalCode':
                                order = 3;
                                break;
                            default:
                                break;
                        }
                        var element_fieldset = {
                            name: element.name,
                            title: element.title,
                            type: 'fieldset',
                            children: [element]
                        }
                        if (order || order === 0) {
                            element_fieldset.order = order;
                            children[key] = { 'type': 'hidden' };
                            newFieldSets.push(element_fieldset);
                        }
                    });

                    newFieldSets.sort(function (a, b) {
                        return a.order - b.order;
                    });

                    for (var i = 0; i < newFieldSets.length; i++) {
                        args.form_definition.form_elements.push(newFieldSets[i]);
                    };

                    // console.log(newFieldSets);
                }
            });
        };

        return args;
    };

    // css to rename a field's placeholder text
    var addCustomCSS = function () {
        setTimeout(() => {
            var phone = document.querySelector('.intl-phone-MobilePhone');
            if (phone) phone.setAttribute('placeholder', 'Phone');
        }, 250);
    };

    nvtag_callbacks.alterFormDefinition.push(addCustomCSS);
    if (inlineNGP) nvtag_callbacks.alterFormDefinition.push(reorderFieldsCallback);
})